// utilities
import "./utilities/animations";

// lightbox
require('fslightbox');

// components
import "../../template-parts/blocks/_mm-blocks/main-navigation/script";
import "./components/accordion";
// import "./components/video";
// import "./components/modal-search";

// Before & After Gallery Slider
import "./components/bna-gallery-slider";
import "./components/bna-gallery-adult-check";

// blocks
import "../../template-parts/blocks/video-carousel/script";
// import "../../template-parts/blocks/reviews-slider/script";
import "../../template-parts/blocks/photo-gallery-section/script";
import "../../template-parts/blocks/header/script";
import "../../template-parts/blocks/hero/script";
import "../../template-parts/blocks/doctor-achievements/script";
import "../../template-parts/blocks/home-procedure-types/script";
import "../../template-parts/blocks/patient-stories-slider/script";
import "../../template-parts/blocks/_mm-blocks/before-after-comparison/script";
import "../../template-parts/blocks/_mm-blocks/slider/script";
import "../../template-parts/blocks/popup/script";